module.exports = __webpack_public_path__ + "media/img/home/directions/list-11-37489b82d4097ce64693591b499a6e85.svg";